import { navigationActions } from "../reducer";

export const resetClientEventHistoryFilter = () =>
  navigationActions.resetClientEventHistoryFilter();
